import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <SEO
        title="TransCirox – Cookie-Richtlinie | Cookie Policy"
        description="Cookie-Richtlinie der TransCiroX GmbH. Informationen über die Verwendung von Cookies auf unserer Website."
        keywords="Cookie, Cookie-Richtlinie, TransCiroX, Datenschutz, Cookies"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("cookie.hero.title")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>{t("cookie.mainTitle")}</h1>

                {/* Company */}
                <h3>{t("cookie.company_name")}</h3>

                {/* What are cookies */}
                <h3>{t("cookie.what_is_cookie_title")}</h3>
                <p>{t("cookie.what_is_cookie_content")}</p>

                <hr />

                {/* Which cookies do we use */}
                <h3>{t("cookie.cookies_used_title")}</h3>

                {/* Necessary cookies */}
                <h4>{t("cookie.necessary_cookies_title")}</h4>
                <p>{t("cookie.necessary_cookies_content")}</p>

                {/* Functional cookies */}
                <h4>{t("cookie.functional_cookies_title")}</h4>
                <p>{t("cookie.functional_cookies_content")}</p>

                {/* Analytics cookies */}
                <h4>{t("cookie.analytics_cookies_title")}</h4>
                <p>{t("cookie.analytics_cookies_content")}</p>

                <hr />

                {/* Third party cookies */}
                <h3>{t("cookie.third_party_cookies_title")}</h3>
                <p>{t("cookie.third_party_cookies_content_1")}</p>
                <p>{t("cookie.third_party_cookies_content_2")}</p>

                <hr />

                {/* Manage cookie settings */}
                <h3>{t("cookie.control_cookies_title")}</h3>
                <p>{t("cookie.control_cookies_content_1")}</p>
                <p>{t("cookie.control_cookies_content_2")}</p>

                <hr />

                {/* Your rights */}
                <h3>{t("cookie.your_rights_title")}</h3>
                <p>{t("cookie.your_rights_intro")}</p>
                <ul>
                  <li>{t("cookie.rights.l1")}</li>
                  <li>{t("cookie.rights.l2")}</li>
                  <li>{t("cookie.rights.l3")}</li>
                  <li>{t("cookie.rights.l4")}</li>
                  <li>{t("cookie.rights.l5")}</li>
                  <li>{t("cookie.rights.l6")}</li>
                </ul>
                <p>{t("cookie.your_rights_footer")}</p>

                <hr />

                {/* Footer */}
                <div className="document-meta">
                  <p>{t("cookie.last_updated")}</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}